module.exports = __webpack_public_path__ + "img/sld_annunciator_t1_b1.cc0bab8a.svg";